import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import * as TYPES from "./actionTypes";
import * as ACTIONS from "./actions";
import * as API from "helpers/backend_helper";

function* sendEmail({ payload: { data, callback } }) {
  try {
    const response = yield call(API.postJoinUs, data);
    callback && callback(response);
    if (response.status == "failure") {
      return yield put(ACTIONS.sendEmailFailed(response.message));
    } 
    yield put(ACTIONS.sendEmailSuccessful(response));
  } catch (error) {
    yield put(ACTIONS.sendEmailFailed("Internal Server Error"));
  }
}

export function* watchsendEmail() {
  yield takeEvery(TYPES.SEND_EMAIL, sendEmail);
}

function* joinUsSaga() {
  yield all([fork(watchsendEmail)]);
}

export default joinUsSaga;
